import React from "react";
import styled from "styled-components";
import { colours, richTextHelper, device } from "@helpers";
import { useLightboxContext } from "@hooks";

import Icon from "@components/Icon";

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

const Content = styled.div`
  position: relative;
  width: 100%;
  padding: 85px 69px 59px;
  border-top-left-radius: 60px;
  background-color: ${colours.PALE_PEACH};

  @media (max-width: ${device.tablet}) {
    border-top-left-radius: 32px;
    padding: 68px 39px 54px;
  }

  @media (min-width: ${device.tablet}) and (max-width: ${device.laptop}) {
    padding: 81px 64px 58px;
  }

  @media (min-width: ${device.laptop}) and (max-width: ${device.desptop}) {
    border-top-left-radius: 80px;
    padding: 103px 95px 45px;
  }

  @media (min-width: ${device.desktop}) {
    padding: 103px 415px 102px;
    border-top-left-radius: 80px;
  }
`;

const Headline = styled.p`
  font-family: EuclidCircularAMedium !important;
  font-size: 32px;
  font-weight: 500;

  @media (max-width: ${device.tablet}) {
    font-size: 22px !important;
  }

  @media (min-width: ${device.tablet}) and (max-width: ${device.laptop}) {
    font-size: 26px !important;
  }

  @media (min-width: ${device.laptop}) {
    font-size: 34px !important;
  }
`;

const MainText = styled.p`
  margin-top: 25px;
  font-size: 22px;

  @media (max-width: ${device.tablet}) {
    font-size: 16px !important;
  }

  @media (min-width: ${device.tablet}) and (max-width: ${device.laptop}) {
    font-size: 18px !important;
  }

  @media (min-width: ${device.laptop}) {
    font-size: 26px !important;
  }
`;

// TODO: if there are too many icons we may need to extra this to a Icon components
// so that we do not need to remember all the names (content) for the icons
const ButtonContainer = styled.div`
  position: absolute;
  top: 35px;
  right: 35px;
  font-size: 18px;
  object-fit: contain;

  :hover {
    cursor: pointer;
  }

  @media (max-width: ${device.tablet}) {
    top: 30px;
    right: 29px;
    font-size: 11px !important;
  }

  @media (min-width: ${device.tablet}) and (max-width: ${device.laptop}) {
    top: 34px;
    right: 33px;
    font-size: 27px !important;
  }

  @media (min-width: ${device.laptop}) and (max-width: ${device.desktopS}) {
    top: 54px;
    right: 66px;
    font-size: 22px !important;
  }

  @media (min-width: ${device.desktop}) {
    top: 54px;
    right: 78px;
    font-size: 22px !important;
  }

  & > div.icon-close-felix {
    @media (max-width: ${device.mobileXL}) {
      font-size: 20px !important;
    }

    @media (min-width: ${device.laptop}) and (max-width: ${device.desktopS}) {
      font-size: 22px !important;
    }
  }
`;

const ContentfulModuleLightBox = ({ content }) => {
  const { removeLightboxContext: closeLightbox } = useLightboxContext();
  const headline = content && content.headline;
  const mainTextContent = content && content.mainText;

  return (
    <Container className="full-size-modal">
      <Content>
        <ButtonContainer onClick={closeLightbox}>
          <Icon iconName="close" />
        </ButtonContainer>
        <Headline>{headline}</Headline>
        <MainText>{richTextHelper(mainTextContent)}</MainText>
      </Content>
    </Container>
  );
};

export default ContentfulModuleLightBox;
